import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

const scrollReveal = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } },
};

const RegistrationCertificationscomponents = () => {
  const steps = [
    { description: "EPF & ESI Registration" },
    { description: "Factory License" },
    { description: "FSSAI License" },
    { description: "GeM (Government e-Marketplace) Registration" },
    { description: "GST Registration" },
    { description: "Import Export Code (IEC)" },
    { description: "ISO Certification" },
    { description: "MSME Sustainable (ZED) Certification" },
    { description: "PAN (Permanent Account Number)" },
    { description: "Pollution Control Board (NOC)" },
    { description: "Professional Tax (PT) Registration" },
    { description: "Shop & Establishment Act License" },
    { description: "TAN (Tax Deduction and Collection Account Number)" },
    { description: "Udyam Registration" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    serviceType: "Registration and Certifications",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "mobile") {
      value = value.replace(/^\+?91/, "");
      value = value.replace(/^0+/, "");
      value = value.replace(/\D/g, "");
      value = value.slice(0, 10);
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/contact`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success("Details sent, our team will contact you soon", {
          position: "top-center",
          autoClose: 3000,
        });

        setFormData({
          name: "",
          email: "",
          mobile: "",
          serviceType: "Registration and Certifications",
          message: "",
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        position: "top-center",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      className="loan-steps-main-smco"
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <motion.div className="loan-container-smco" variants={staggerContainer}>
        
        {/* LEFT SECTION */}
        <motion.div
          className="loan-step-left-container-smco"
          variants={staggerContainer}
        >
          <motion.h2
            className="loan-step-left-container-title-smco"
            variants={scrollReveal}
          >
            Expert assistance in business registration, certifications and
            compliance.
          </motion.h2>

          <motion.div
            className="loan-step-left-container-timeline-smco"
            variants={staggerContainer}
          >
            {steps.map((step, index) => (
              <motion.div
                key={index}
                className={`loan-step-left-container-step-smco ${
                  index === steps.length - 1
                    ? "loan-step-left-container-last-step-smco"
                    : ""
                }`}
                variants={scrollReveal}
              >
                <motion.div
                  className="loan-step-left-container-number-smco"
                  variants={scrollReveal}
                >
                  {index + 1}
                </motion.div>
                <motion.p
                  className="loan-step-left-container-description-smco"
                  variants={scrollReveal}
                >
                  {step.description}
                </motion.p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>

        {/* RIGHT SECTION */}
        <motion.div
          className="loan-step-right-container-smco"
          variants={staggerContainer}
        >
          <motion.h3 className="contact-us-header-smco" variants={scrollReveal}>
            Contact Us for Registration and Certifications
          </motion.h3>

          <form onSubmit={handleSubmit}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              className="contact-page-smco-input"
              onChange={handleChange}
              placeholder="Your Name"
              required
            />

            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              className="contact-page-smco-input"
              onChange={handleChange}
              placeholder="Your Email"
              required
            />

            <label>Phone Number</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              className="contact-page-smco-input"
              placeholder="Your Number"
              onChange={handleChange}
              required
            />

            <label>Service Type</label>
            <select
              className="contact-page-smco-input"
              name="serviceType"
              value={formData.serviceType}
              onChange={handleChange}
              required
            >
              <option value="Registration and Certifications">
                Registration and Certifications
              </option>
            </select>

            <label>Message</label>
            <textarea
              className="contact-page-smco-input"
              placeholder="Your Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>

            <button type="submit" className="contact-page-smco-button">
              {loading ? <span className="spinner"></span> : "Submit"}
            </button>
          </form>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default RegistrationCertificationscomponents;
